import { ReactNode } from "react";
import { Box, Group, Stack, Title } from "@mantine/core";

export interface SectionGroupProps {
    title: string;
    // Left accent bar colour — used to distinguish campaign-wide vs per-product groups.
    accent: string;
    // Optional right-aligned control (e.g. the per-product switcher).
    action?: ReactNode;
    children: ReactNode;
}

// A top-level grouping of report sections, with a prominent heading and a coloured
// accent bar so it's obvious which cards are campaign-wide vs per-product.
export const SectionGroup = ({ title, accent, action, children }: SectionGroupProps) => (
    <Stack spacing="xl">
        <Group position="apart" align="center" noWrap>
            <Group spacing="sm" noWrap>
                <Box style={{ width: 4, height: 26, borderRadius: 2, background: accent, flex: "none" }} />
                <Title order={3} sx={{ color: "#0F1B3D", fontWeight: 800 }}>
                    {title}
                </Title>
            </Group>
            {action}
        </Group>
        {children}
    </Stack>
);
